export default {
  trends: {
    title: "Tendências",
    navigation: {
      gameSummary: "Resumo do jogo",
    },
    tabs: {
      player: "Jogador",
      team: "Equipe",
      parlay: "Parlay",
      sgp: "SGP",
      stats: "Estatísticas",
    },
    help: {
      title: "Tendências",
      description: "O Linemate usa estes sinais para mostrar a força e o contexto por trás de cada tendência.",
      items: {
        recentForm: "Taxa de sucesso na forma recente",
        headToHead: "Taxa de sucesso em confrontos diretos",
        homeAway: "Taxa de sucesso em jogos em casa e fora",
        starter: "Taxa de sucesso jogando como titular (Linemate+)",
        injuryImpact: "Impacto de lesões de companheiros (Linemate+)",
        opponentRank: "Ranking defensivo do adversário (Linemate+)",
      },
    },
    empty: {
      noTrendsAvailable: "Nenhuma tendência disponível",
      clearFilters: "Limpar filtros",
      offseasonTitle: "Atualmente na entressafra",
      minimumGames: "Mínimo de 3 jogos necessário",
    },
    analysis: {
      title: "Análise da tendência",
      viewProfile: "Ver perfil",
      addToMyPicks: "Adicionar às Minhas escolhas",
      removeFromMyPicks: "Remover das Minhas escolhas",
      addParlayToMyPicks: "Adicionar parlay às Minhas escolhas",
      removeParlay: "Remover parlay",
      addLegToMyPicks: "Adicionar leg às Minhas escolhas",
      removeLegFromMyPicks: "Remover leg das Minhas escolhas",
      sections: {
        playerForm: "Forma do jogador",
        playerPerformance: "Desempenho do jogador",
        teamPerformance: "Desempenho do time",
        teamForm: "Forma do time",
        startingLineup: "Escalação inicial",
        injuries: "Lesões",
        startingPitcher: "Arremessador titular",
        batterVsPitcher: "Rebatedor vs arremessador",
        opponentDefensiveRank: "Ranking defensivo do adversário",
        weather: "Tempo",
        lockedAdvancedTools: "Veja mais com Linemate+",
        parlayLegs: "Legs",
      },
      labels: {
        status: "Status",
        player: "Jogador",
        type: "Tipo",
        viewGames: "Ver jogos",
        quickCheckout: "Checkout rápido",
        showAll: "Mostrar tudo",
        close: "Fechar",
        openOnProvider: "Abrir em {{provider}}",
        visitProvider: "Visitar {{provider}}",
        recentForm: "Forma recente",
        headToHead: "Confronto direto",
        location: "Local",
        lastFive: "Últimos 5",
        asStarter: "Como titular",
        startingPitcher: "Arremessador titular",
        overallRank: "Ranking geral",
        positionalRank: "Ranking posicional",
        confirmed: "Confirmado",
        expected: "Esperado",
        withoutPlayer: "Sem {{player}}",
        rankVsPosition: "Ranking vs {{position}}",
        impactOn: "Impacto em {{target}}",
        defensiveRankAgainst: "Ranking defensivo de {{team}} ‧ {{betType}} contra",
        vsPitcher: "vs {{pitcher}}",
        atBatsSummary: "{{value}} {{stat}} em {{atBats}} at-bats",
        gamesSuffix: " jogos",
        noSignalsFound: "Nenhum sinal encontrado para esta tendência",
        noStarterSignal: "Não há sinal de titular",
        noStartingLineupsYet: "Ainda não há escalações iniciais",
        noInjuryReportSignal: "Não há sinal de relatório de lesões",
        noInjuries: "Atualmente não há lesões",
      },
      summaryCards: {
        recentForm: "Forma recente",
        headToHead: "Confronto direto",
        homeSplit: "Divisão em casa",
        awaySplit: "Divisão fora",
        recordGames: "{{record}} jogos",
        recordVs: "{{record}} vs {{opponent}}",
        recordAtHome: "{{record}} em casa",
        recordAway: "{{record}} fora",
      },
      paywall: {
        title: "Desbloqueie a análise completa da tendência",
        body: "Veja o impacto de cada sinal avançado.",
      },
      preview: {
        injuryImpact: "Relatório de lesões",
        opponentRank: "Ranking defensivo do adversário",
        recordPlaceholder: "100% ⋅ 00 dos últimos 00 jogos",
        opponentRankPlaceholder: "00º • Positivo",
        weatherPlaceholder: "Nublado",
      },
      weatherDirections: {
        inToOut: "De dentro para fora",
        outToRight: "De fora para a direita",
        outToIn: "De fora para dentro",
        inFromLeft: "Entrando pela esquerda",
        inFromRight: "Entrando pela direita",
        leftToRight: "Da esquerda para a direita",
        outToLeft: "De fora para a esquerda",
        rightToLeft: "Da direita para a esquerda",
        unknown: "Desconhecido",
      },
      hints: {
        addTrendToMyPicks: "Adicione esta tendência às Minhas escolhas para fazer sua aposta",
        swipeToAddTrend: "Deslize para a esquerda para adicionar rapidamente uma tendência às Minhas escolhas.",
        swipeAddLabel: "Adicionar",
      },
      imageImport: {
        noPicksFound: "Nenhuma escolha encontrada",
        noPicksBody: "Não conseguimos encontrar escolhas nesta imagem.",
        analyze: "Analisar",
      },
      gamelog: {
        title: "Gamelog",
        titleWithout: "Jogos disputados sem {{name}}",
        chips: {
          last10: "Últimos 10",
          headToHead: "Confronto direto",
          homeSplits: "Divisões em casa",
          awaySplits: "Divisões fora",
          versusPitcher: "vs. {{pitcher}}",
        },
        headers: {
          hit: "Acertou",
          date: "Data",
          versus: "Contra",
          result: "Resultado",
          comp: "Comp",
        },
      },
    },
    stats: {
      sections: {
        records: "Registros",
        headToHead: "Confronto direto",
        last5Games: "Últimos 5 jogos",
        rankings: "Rankings",
        injuries: "Lesões",
        gameDetails: "Detalhes do jogo",
      },
      picker: {
        season: "Temporada",
        last5: "Últimos 5",
        headToHead: "Confronto direto",
      },
      rows: {
        recentForm: "Últimos 5 jogos",
        season: "Copa do Mundo 2026",
        overall: "Geral",
        home: "Início",
        away: "Fora",
      },
      rankings: {
        for: "A FAVOR",
        against: "CONTRA",
      },
    },
  },
};
